import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { API_URL, REACT_APP_VERSION } from "./config";
import { getCustomerDataWithRefreshToken } from "./services/customer";
import { store } from "./redux";
import { setReloadAppDialog } from "./redux/slices/appActions/appActionsSlice";
import { showHttpError } from "./utils/message";
import { fakeDelay } from "./newSrc/utils/helper";
export const endPoint =
  process.env.REACT_APP_API_URL || API_URL[process.env.NODE_ENV as any];
export const baseURL = endPoint + "/api";

const test = process.env.NODE_ENV == "test";
const attachJWT : any = (config: AxiosRequestConfig) => {
  const { url } = config;
  // if (controllers.has(url)) {
  //   controllers.get(url).abort();
  //   controllers.delete(url);  // Remove old controller from Map
  // }
  const oldHeaders : any = { ...config.headers };
  if (url && !url.includes("taptapassets")) {
    const role = localStorage.getItem("loginBy");
    const loginFromForm = sessionStorage.getItem("loginFromForm");
    oldHeaders.authorization = (!loginFromForm && role === "transporter") ? localStorage.getItem("kabra:token") : localStorage.getItem("kabra:customertoken")
  }

  // const controller = new AbortController();
  // config.signal = controller.signal;
  // controllers.set(url, controller);

  return {
    ...config,
    headers: {
      ...oldHeaders,
       'ngrok-skip-browser-warning': 'true' 
    },
  };
};

let reloadNotified = false;
const reactVersionRegex = /^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/;
const checkReactVersion = (response: AxiosResponse<any>) => {
  try {
    if (reloadNotified === false) {
      let newVersionRequired = false;
      const version = response.headers && response.headers["x-rv"];
      if (
        REACT_APP_VERSION &&
        typeof version === "string" &&
        reactVersionRegex.test(version) &&
        reactVersionRegex.test(REACT_APP_VERSION)
      ) {
        const reactVArray = REACT_APP_VERSION.split(".");
        const requiredVArray = version.split(".");
        for (let i = 0; i < 3; i++) {
          if (Number(reactVArray[i]) < Number(requiredVArray[i])) {
            newVersionRequired = true;
          } else if (Number(reactVArray[i]) > Number(requiredVArray[i])) {
            break;
          }
        }
      }
      if (newVersionRequired) {
        reloadNotified = true;
        store.dispatch(setReloadAppDialog(true));
      }
    }
  } catch (e) {}
  return response;
};
// const role1 = sessionStorage.getItem("role");
const API = axios.create({
  baseURL: baseURL + "/",
  headers: {
    authorization: localStorage.getItem("kabra:token"),
'ngrok-skip-browser-warning': 'true', 
  },
});

// const controllers = new Map();

const handleERPRefreshToken = async (originalRequest : any) => {
  try {
    const refreshToken = localStorage.getItem("kabra:refreshToken")
    const payload = {
      rt : refreshToken,
      isCustomer:false,
      isUser:true
    };
    const newToken = await getCustomerDataWithRefreshToken(payload)
    if (newToken) {
      // Update the authorization header in the original request
        originalRequest.headers['Authorization'] = `Bearer ${newToken.accessToken}`;
        localStorage.setItem("kabra:token", newToken.accessToken);
        localStorage.setItem("kabra:refreshToken", newToken.refreshToken);
      // Update tokens in storage
      // Retry the original request with the new token
      return axios(originalRequest);
    }
  } catch (tokenRefreshError) {
    localStorage.removeItem("kabra:token");
    localStorage.removeItem("kabra:refreshToken");
    showHttpError("Session expired!", 3000);
    await fakeDelay(2000);
    // window.location.reload();
    return Promise.reject(tokenRefreshError);
  }
}

const handleCustomerRefreshToken = async (originalRequest : any) => {
  try {
    const refreshToken = localStorage.getItem("refreshToken")
    const payload = {
      rt : refreshToken,
      isCustomer:true,
      isUser:false
    };
    const newToken = await getCustomerDataWithRefreshToken(payload)
    // const res = await axios.post(baseURL + "/getIdToken", payload, {
    //   withCredentials: true,
    // });
    // const newToken = res.data?.response
    if (newToken) {
      // Update the authorization header in the original request
        originalRequest.headers['Authorization'] = `Bearer ${newToken.accessToken}`;
        localStorage.setItem("kabra:customertoken", newToken.accessToken);
        localStorage.setItem("kabra:customer", newToken.customer._id);
        localStorage.setItem("refreshToken", newToken.refreshToken);
        localStorage.setItem("refreshTokenExpiresAt", newToken.refreshTokenExpiresAt);
      // Update tokens in storage
      // Retry the original request with the new token
      return axios(originalRequest);
    }
  } catch (tokenRefreshError) {
    localStorage.removeItem("kabra:customertoken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("refreshTokenExpiresAt");
    showHttpError("Session expired!", 3000);
    await fakeDelay(2000);
    // window.location.reload();
    return Promise.reject(tokenRefreshError);
  }
}
// API.defaults.withCredentials = true;

// if (!test) {
//   API.interceptors.request.use(attachJWT);
//   axios.interceptors.request.use(attachJWT);
//   API.interceptors.response.use(checkReactVersion);
//   axios.interceptors.response.use(checkReactVersion);
// }

if (!test) {
  API.interceptors.request.use(attachJWT);
  axios.interceptors.request.use(attachJWT);
  axios.interceptors.response.use(checkReactVersion);
  // Add a response interceptor
  API.interceptors.response.use(
    (response) => {
      // controllers.delete(response.config.url);
      checkReactVersion(response);
      return response;
    },
    async (error) => {
      const originalRequest = error.config;
      const role = localStorage.getItem("loginBy");
      if (axios.isCancel(error)) {
        // console.log("Request canceled:", error.message);
      }
      // if (error.config) {
      //   controllers.delete(error.config.url);
      // }
      if (error.response && error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        if(role === "customer"){
          handleCustomerRefreshToken(originalRequest)
        }
       else{
        handleERPRefreshToken(originalRequest)
       }
      }
      return Promise.reject(error);
    }
  );
}


export default API;
